import compose from "recompose/compose";
import withProps from "recompose/withProps";
import {withFormik} from "formik";
import * as Yup from "yup";
import moment from "moment";
import opt from "@gqlapp/base/utils/opt";
import { withFirebaseAuth } from "@xem/user-common/classes/firebase";
import withFirebase, { withFirebaseProcess } from "./withFirebase";
import { withLoginQuery } from "@xem/user-common/classes/withUserLogin";
import withUserProcess from "../helpers/utils";
import withUserRegister from "@xem/user-common/classes/withUserRegister";
import countries from '@gqlapp/config/country/countries';

/**
 * validationSchema
 */
function validationSchema({}: any) {
  return Yup.object().shape({})
}

/**
 * handleSubmit
 * @param displayName
 * @param level
 * @param sex
 * @param birthday
 * @param code
 * @param auth
 * @param phone
 * @param values
 * @param resetForm
 * @param setValues
 * @param props
 */
async function handleSubmit(
  { displayName, level, sex, birthday, code, auth, phone, ...values }: any,
  { resetForm, setValues, props}: any){
  let { doLogin, onRegister, confirmationResult, setConfirmationResult, signInWithPhoneNumber } = props
  let { phoneNumber, area } = phone || {};
  const { day, month, year} = birthday || {};
  auth = auth || [];

  const setLevel = (level: number)=>{
    resetForm();
    setValues({ ...values, displayName, sex, auth, level, birthday, code, phone });
  }

  switch (level){
    default:
      setLevel(1);
      break;
    case 1:
      let options = countries;
      let { phone: phonearea } = opt(options, area)
      phoneNumber = phoneNumber.replace(/\D/g, "");
      signInWithPhoneNumber(`+${phonearea}${phoneNumber}`).then(()=>setLevel(2));
      break;
    case 2:
      code = code.replace(/[^\w]/g, "");
      try{
        confirmationResult.confirm(code).then(({ user:{ uid, refreshToken } })=>{
          if(!!(uid && refreshToken)){
            auth = auth.filter(({providerId}) => providerId !== 'phone');
            auth.push({ uid, token: refreshToken, providerId: 'phone'});
            if(day && month && year){ birthday = moment(`${year}-${month}-${day}`); }
            onRegister({ ...values, auth, profile:{ displayName, sex, birthday } })
              .then(async ({ entity: { session: variables } })=>{
                resetForm();setLevel(1);
                await setConfirmationResult(null);
                await doLogin(variables);
              })
              .catch(errorCatch);
          }
        }).catch(errorCatch)
      }catch (e) {
        errorCatch(e);
      }
      break;
  }
}

/**
 *
 * @param providerId
 * @param currentUser
 */
function mapPropsToValues({ providerId, currentUser }) {
  let { email, displayName, sex, uid, refreshToken } = currentUser || {}
  let password: string, passwordConfirmation: string, auth = [];

  // let now     = Number(moment().format('YYYY'));
  // let days    = ([...Array(32).keys()].slice(1)).map(value => ({value, label: `${value}`}));
  // let months  = ([...Array(13).keys()].slice(1)).map(value => ({value, label: `${value}`}));
  // let years   =  ([...Array(now).keys()].slice(now - 200, now)).sort((a, b)=> b - a).map(value=> ++value).map(value => ({value, label: `${value}`}));

  // day = getval(days[0]);
  // month = getval(months[0]);
  // year = getval(years[0]);


  if(typeof providerId !== 'undefined' && providerId !== 'phone') {
    auth.push({
      uid,
      token: refreshToken,
      providerId
    })
  }

  return ({
    auth,
    level: 0,
    phone: '',
    displayName,
    mail: email || '',
    password: password || '',
    passwordConfirmation: passwordConfirmation || '',
    birthday: { day: null, month: null, year: null },
    sex: sex || 'male'
  })
}


export default compose(
  withLoginQuery,
  withUserRegister,
  withUserProcess,
  withFirebaseAuth,
  withFirebaseProcess,
  withFirebase,
  withFormik({
    mapPropsToValues,
    validationSchema,
    handleSubmit,
    enableReinitialize: true,
    displayName: 'SignUpForm' // helps with React DevTools
  }),
  withProps(({ setValues })=>({
    setRegisterValues: (values: any, level: number)=> setValues({ ...values, level })
  }))
);
